import Model from "./../core/Model";

export default class Supplier extends Model
{
    constructor( options = {} )
    {
        super('/api/v1/suppliers/');

        this.setOptions(options);
    }

    setOptions( options = {} )
    {
        let lang          = document.documentElement.lang || null;

        this.id           = options.id         || null;
        this.content      = options.content    || null;
        this.locale       = options.locale     || lang;
    }

    toJson ()
    {
        return {
            id      : this.id,
            content : this.content,
            locale  : this.locale,
        }
    }
}



// WEBPACK FOOTER //
// ./resources/js/models/Comment.js